import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgIf} from "@angular/common";
import {IconComponent} from "../../elements/icon/icon.component";
import {Icons} from "../../../model/icon";

@Component({
  selector: 'app-panorama',
  imports: [
    NgIf,
    IconComponent
  ],
  templateUrl: './panorama.component.html',
  styleUrl: './panorama.component.scss'
})
export class PanoramaComponent {
  @Input() panoramaKey: string = "";
  @Output() close = new EventEmitter();
  play: boolean = false;
  protected readonly Icons = Icons;
}
